import { processUrlParameters } from './urlNormalization';

processUrlParameters();

import('./mainApp');
